import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'modelo25',
    loadChildren: () => import('./modelo25/modelo25.module').then( m => m.Modelo25PageModule)
  },
  {
    path: 'modelo35',
    loadChildren: () => import('./modelo35/modelo35.module').then( m => m.Modelo35PageModule)
  },
  {
    path: 'urban',
    loadChildren: () => import('./urban/urban.module').then( m => m.UrbanPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
